import { Box, BoxProps, styled } from "@mui/material";
interface ScrollContainerProps extends BoxProps {
    maxHeight?: string;
    showVerticalScroll?: boolean;
}
export const ScrollContainer = styled((props: ScrollContainerProps) => (<Box {...props} />))(({ maxHeight = '200px', showVerticalScroll }) => ({
    maxHeight: maxHeight,
    overflowY: showVerticalScroll ? 'auto' : 'scroll',
    overflowX: 'hidden',
    ...(showVerticalScroll
        ? {}
        : {
            scrollbarWidth: 'none', // Firefox
            msOverflowStyle: 'none', // IE y Edge
            '&::-webkit-scrollbar': {
                display: 'none', // Chrome, Safari y WebKit
            },
        }),
}))